/** @module Enums */ /** typedoc */
/**
 * Intensity used to master.
 * Basic intensities are `Low`, `Medium` and `High`.
 * Extra intensity is `Loud` and lead to some limitations.
 */
var IntensityEnum;
(function (IntensityEnum) {
    IntensityEnum["Low"] = "Low";
    IntensityEnum["Medium"] = "Medium";
    IntensityEnum["High"] = "High";
    IntensityEnum["Loud"] = "Loud";
})(IntensityEnum || (IntensityEnum = {}));

export { IntensityEnum };
